import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import ActionHeader from './header';
import { Row, Col, Container, Wrapper } from '../../components/layout';
import {  PrimaryButton } from '../../components/buttons';
import PlayerLinkIcon from '../../assets/icons/player-link.svg';
// import { SvgIconContainer } from '../../components/icons';
import { PlayerLastName, PlayerFirstName } from '../../components/text';
import { useParams, useHistory } from 'react-router-dom';
import useSaveGuestOrGetItem from '../../lib/hooks/useSaveOrGetItem';
import LoadingIndicator from '../../components/loading';
import { ExitRankingsModal, SaveItemModal } from '../../components/modal';
// import {  updateItemToWP } from '../../actions/api';
import { getPlayerLink, mobileBreakpoint, parseHeight } from '../../lib';
import useGetUserData from '../../lib/hooks/useGetUserData';
import { PresentedBy, SocialMediaList, PlayerFlag } from '../../components';
import { useMediaQuery } from 'react-responsive';
import { TableHeading, Th, PlayerRow, Td, RowsContainer } from '../../components/table';
import { sponsorsStore } from '../../store';

const ShareText = styled.h3`
    font-weight: 400;
    margin-right: 28px;
    @media(max-width: 900px){
        visibility: hidden;
        display: none;
    }
`;
const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const PickNumber = styled.span`
    font-size: 14px;
    font-weight: 700;
`

const ResultsWrapper = styled(Wrapper)`
    max-width: 920px;
    margin-top: 0;
    padding-top: 0px;
    @media(max-width: 900px){
        padding: 0;
    }
`
const HeaderWrapper = styled(Wrapper)`
    margin-top: 0;
    padding-top: 0px;
`

const SocialMediaRow = styled.div`
    display: flex;
    align-items: center;
`;

export const FcRank = styled.span`
    color: #bababa;
`;

const desktopColumnSizes = [
    {size: '9%',  label: 'User Rank'},
    {size: '6%',  label: 'Fc Rank'},
    {size: '2%',  label: ''},
    {size: '30%', label: 'Player'},
    {size: '5%',  label: 'Pos.'},
    {size: '17%', label: 'Team'},
    {size: '8%', label: 'League'},
    {size: '8%', label: 'HT.'},
    {size: '10%', label: 'WT.'},
    {size: '5%',  label: 'Nat'},
];
const mobileColumnSizes = [
    {size: '9%',  label: 'User Rank'},
    {size: '8%',  label: 'Fc Rank'},
    {size: '40%', label: 'Player'},
    {size: '5%',  label: 'Pos.'},
    {size: '28%', label: 'Team'},
    {size: '15%', label: 'League'},
];

const PlayerLinkIconContainer = styled.img.attrs(props => ({
    src: props.src
  }))`
    margin-left: 3px;
    position: absolute;
    top: 3px;
`;  

const Player = ({player, isMobile, position, altRow}) => (
    isMobile ?
    <RowsContainer altRow={altRow}>
        <PlayerRow >
            <Td width={mobileColumnSizes[0].size}>
                <Row justifyContent="center"><PickNumber>{position}</PickNumber></Row>
            </Td>
            <Td width={mobileColumnSizes[1].size}>
                <Row justifyContent="center"><FcRank>{player.fcRank}</FcRank></Row>
            </Td>
            <Td width={mobileColumnSizes[2].size}>
                <PlayerLastName>{player.lastName}</PlayerLastName>
                <PlayerFirstName>{player.firstName}</PlayerFirstName>
            </Td>
            <Td width={mobileColumnSizes[3].size}>{player.position}</Td>
            <Td width={mobileColumnSizes[4].size}>{player.team}</Td>
            <Td width={mobileColumnSizes[5].size}>{player.league}</Td>
        </PlayerRow>
    </RowsContainer>
    :
    <RowsContainer altRow={altRow}>
        <PlayerRow >
            <Td width={desktopColumnSizes[0].size}>
                <Row justifyContent="center"><PickNumber>{position}</PickNumber></Row>
            </Td>
            <Td width={desktopColumnSizes[1].size}>
                <Row justifyContent="center"><FcRank>{player.fcRank}</FcRank></Row>
            </Td>
            <Td width={desktopColumnSizes[2].size}/>
            <Td width={desktopColumnSizes[3].size}>
                <PlayerLastName>{player.lastName}</PlayerLastName>
                <PlayerFirstName>{player.firstName}</PlayerFirstName>
                <a href={getPlayerLink(player)} target="_blank" rel="noopener noreferrer"><PlayerLinkIconContainer src={PlayerLinkIcon}/></a>
            </Td>
            <Td width={desktopColumnSizes[4].size}>{player.position}</Td>
            <Td width={desktopColumnSizes[5].size}>{player.team}</Td>
            <Td width={desktopColumnSizes[6].size}>{player.league}</Td>
            <Td width={desktopColumnSizes[7].size}>{parseHeight(player.height)}</Td>
            <Td width={desktopColumnSizes[8].size}>{player.weight} lbs</Td>
            <Td width={desktopColumnSizes[9].size}>
                <PlayerFlag player={player} width="24px" height="13px" marginLeft="0px" />
            </Td>
        </PlayerRow>
    </RowsContainer>
)

async function saveRankingsToAccount(data, title, userId, postId, history, setSubmitting){
    setSubmitting(true);
    // const result = await updateItemToWP(data, 'user_rankings', title, postId, userId);
    setSubmitting(false);
    history.push('/my-rankings');
}

function RankingsResults({ rankedPlayers }){
    let history = useHistory();
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    const { state: { rankingsBuilder } } = useContext(sponsorsStore);
    const [ submitting, setSubmitting ] = useState(false);
    const [ isExitModalOpen, setExitModalOpen ] = useState(false);
    const [ isSaveModalOpen, setSaveModalOpen ] = useState(false);
    const [ title, setTitle ] = useState('');
    const { rankingId } = useParams();
    const { userId, username, userCanSave } = useGetUserData();
    const [ data, loading ] = useSaveGuestOrGetItem(rankingId, { rankedPlayers }, 'user_rankings');
    return (
        <HeaderWrapper>
            <ExitRankingsModal
                isOpen={isExitModalOpen}
                handleModalOpen={setExitModalOpen}
                handleSaveModalOpen={setSaveModalOpen}
                userCanSave={userCanSave}
            />
            <SaveItemModal
                isOpen={isSaveModalOpen}
                handleModalOpen={setSaveModalOpen}
                item="rankings"
                userRole=""
                title={title}
                setTitle={setTitle}
                submitting={submitting}
                saveItem={() => saveRankingsToAccount({rankedPlayers, username}, title, userId, data.wpID, history, setSubmitting)}
            />
            {!rankingId && <ActionHeader
                heading="Rankings"
                subHeading={<SocialMediaRow><ShareText>Share results</ShareText><SocialMediaList postId={data.wpID} type="rankings"/></SocialMediaRow>}
                userId={userId}
                handleOpenSaveModal={()=>setSaveModalOpen(true)}
                handleOpenExitModal={()=>setExitModalOpen(true)}
                userCanSave={userCanSave}
            /> }
            {loading ? <LoadingIndicator />: <ResultsWrapper>
                {rankingId && <Row alignItems="center" justifyContent="space-between" margin="30px 0 10px 0">
                    <Col>
                        <PrimaryButton onClick={() => history.push('/rankings-builder')}>Start your own rankings</PrimaryButton>
                    </Col>
                    <Col alignItems="center">
                        <PresentedBy logo={rankingsBuilder.url}/>
                    </Col>
                </Row>}
                <Row alignItems="center" justifyContent="space-between" margin="0 0 10px 0">
                    <Col><h1>{`${data.username ? data.username + "'s" : ''}`} Rankings</h1></Col>
                </Row>
                <Container>
                    <TableHeading>
                    { isMobile ? mobileColumnSizes.map((col, idx)=> <Th key={idx} width={col.size}>{col.label.toUpperCase()}</Th>) : desktopColumnSizes.map((col, idx)=> <Th key={idx} width={col.size}>{col.label.toUpperCase()}</Th>)}
                    </TableHeading>
                    <TableContainer>
                    {data.rankedPlayers.map((player, id)=> <Player altRow={id % 2 !== 0} key={player.id} player={player} isMobile={isMobile} position={id + 1}/>)}
                    </TableContainer>
                </Container>
            </ResultsWrapper>}
        </HeaderWrapper>
    )
}

export default RankingsResults;